import { ATTRIBUTE_QUALIFIER_MULTIPLE_LOCATIONS } from "./attributeQualifierTypes.js";

export const ATTRIBUTE_TITLE = 'ATTRIBUTE_TITLE'
export const ATTRIBUTE_DESCRIPTION = 'ATTRIBUTE_DESCRIPTION'
export const ATTRIBUTE_BRAND = 'ATTRIBUTE_BRAND'
export const ATTRIBUTE_PRICE = 'ATTRIBUTE_PRICE'
export const ATTRIBUTE_PICTURE = 'ATTRIBUTE_PICTURE'
export const ATTRIBUTE_INVENTORY = 'ATTRIBUTE_INVENTORY'
export const ATTRIBUTE_TAGS = 'ATTRIBUTE_TAGS'
export const ATTRIBUTE_PRODUCT_TYPE = 'ATTRIBUTE_PRODUCT_TYPE'
export const ATTRIBUTE_PRODUCT_STATUS = 'ATTRIBUTE_PRODUCT_STATUS'
export const ATTRIBUTE_PRODUCT_CATEGORY = 'ATTRIBUTE_PRODUCT_CATEGORY'
export const VARIANT_ATTRIBUTE_SKU = 'VARIANT_ATTRIBUTE_SKU'
export const VARIANT_ATTRIBUTE_WEIGHT = 'VARIANT_ATTRIBUTE_WEIGHT'
export const VARIANT_ATTRIBUTE_BARCODE = 'VARIANT_ATTRIBUTE_BARCODE'
export const VARIANT_ATTRIBUTE_TAXABLE = 'VARIANT_ATTRIBUTE_TAXABLE'
export const VARIANT_ATTRIBUTE_INVENTORY_POLICY = 'VARIANT_ATTRIBUTE_INVENTORY_POLICY'
export const VARIANT_ATTRIBUTE_ITEM_COST = 'VARIANT_ATTRIBUTE_ITEM_COST'
export const VARIANT_ATTRIBUTE_INVENTORY_LOCATION = 'VARIANT_ATTRIBUTE_INVENTORY_LOCATION'
export const VARIANT_ATTRIBUTE_INVENTORY_LOCATION_NAME = 'VARIANT_ATTRIBUTE_INVENTORY_LOCATION_NAME'

export const attributesWithEmptyQualifier = [
  ATTRIBUTE_DESCRIPTION,
  ATTRIBUTE_PRICE,
  ATTRIBUTE_PICTURE,
  ATTRIBUTE_PRODUCT_TYPE,
  ATTRIBUTE_TITLE,
  ATTRIBUTE_BRAND,
  VARIANT_ATTRIBUTE_SKU,
  ATTRIBUTE_TITLE,
  VARIANT_ATTRIBUTE_BARCODE,
  ATTRIBUTE_PRODUCT_CATEGORY,
  VARIANT_ATTRIBUTE_ITEM_COST,
  VARIANT_ATTRIBUTE_INVENTORY_LOCATION,
  VARIANT_ATTRIBUTE_INVENTORY_LOCATION_NAME,
]
export const attributesWithEqualQualifierString = [
  ATTRIBUTE_TITLE,
  ATTRIBUTE_DESCRIPTION,
  ATTRIBUTE_PRICE,
  VARIANT_ATTRIBUTE_ITEM_COST,
  ATTRIBUTE_BRAND,
  ATTRIBUTE_PRODUCT_TYPE,
  ATTRIBUTE_PRODUCT_STATUS,
  VARIANT_ATTRIBUTE_SKU,
  VARIANT_ATTRIBUTE_BARCODE,
  ATTRIBUTE_PRODUCT_CATEGORY
]
export const attributesWithEqualQualifierNumber = [
  ATTRIBUTE_INVENTORY,
  VARIANT_ATTRIBUTE_WEIGHT,
  VARIANT_ATTRIBUTE_INVENTORY_LOCATION
]
export const attributesWithContainsQualifier = [
  ATTRIBUTE_TITLE,
  ATTRIBUTE_DESCRIPTION,
  ATTRIBUTE_BRAND,
  ATTRIBUTE_PRODUCT_TYPE,
  ATTRIBUTE_PRICE,
  VARIANT_ATTRIBUTE_ITEM_COST,
  ATTRIBUTE_TAGS,
  VARIANT_ATTRIBUTE_SKU,
  VARIANT_ATTRIBUTE_BARCODE,
  ATTRIBUTE_PRODUCT_CATEGORY
]
export const attributesWithBooleanQualifier = [
  ATTRIBUTE_INVENTORY,
  VARIANT_ATTRIBUTE_TAXABLE
]
export const attributesWithTags = [
  ATTRIBUTE_TAGS
]
export const attributesWithLargerOrLessQualifier = [
  ATTRIBUTE_PRICE,
  VARIANT_ATTRIBUTE_ITEM_COST,
  ATTRIBUTE_INVENTORY,
  VARIANT_ATTRIBUTE_WEIGHT
]
export const attributesWithInventoryPolice = [
  ATTRIBUTE_INVENTORY
]
export const attributesWithMultipleLocations = [
  VARIANT_ATTRIBUTE_INVENTORY_LOCATION,
  VARIANT_ATTRIBUTE_INVENTORY_LOCATION_NAME,
]
export const attributesWithProductIsNotActive = [
  ATTRIBUTE_PRODUCT_STATUS
]

export const variantAttributes = [
  VARIANT_ATTRIBUTE_SKU,
  VARIANT_ATTRIBUTE_WEIGHT,
  VARIANT_ATTRIBUTE_BARCODE,
  VARIANT_ATTRIBUTE_INVENTORY_POLICY,
  VARIANT_ATTRIBUTE_ITEM_COST,
  VARIANT_ATTRIBUTE_INVENTORY_LOCATION,
  VARIANT_ATTRIBUTE_TAXABLE,
  VARIANT_ATTRIBUTE_INVENTORY_LOCATION_NAME,
]


export const attributesInDb = {
  ATTRIBUTE_TITLE: "title",
  ATTRIBUTE_DESCRIPTION: "description",
  ATTRIBUTE_BRAND: "vendor",
  ATTRIBUTE_PRODUCT_TYPE: "productType",
  ATTRIBUTE_PRODUCT_STATUS: "status",
  ATTRIBUTE_PRODUCT_CATEGORY: "productCategory",
  ATTRIBUTE_PRICE: "maxVariantPrice",
  ATTRIBUTE_PICTURE: "featuredImage",
  ATTRIBUTE_INVENTORY: "totalInventory",
  ATTRIBUTE_TAGS: "tags",
  VARIANT_ATTRIBUTE_SKU: "sku",
  VARIANT_ATTRIBUTE_WEIGHT: "weight",
  VARIANT_ATTRIBUTE_BARCODE: "barcode",
  VARIANT_ATTRIBUTE_TAXABLE: "taxable",
  VARIANT_ATTRIBUTE_INVENTORY_POLICY: "inventoryPolicy",
  VARIANT_ATTRIBUTE_ITEM_COST: "unitCost",
  VARIANT_ATTRIBUTE_INVENTORY_LOCATION: "locationsCount",
  VARIANT_ATTRIBUTE_INVENTORY_LOCATION_NAME: "inventoryLocations",
};